module.exports = __webpack_public_path__ + "img/partner_7.f7f12ebe.png";